import { RouteConfig } from 'vue-router';

const ZhglList = () => import(/* webpackChunkName: "Yhqx" */  './zhanghu/zhgl-list.vue');
const ZhglCompose = () => import(/* webpackChunkName: "Yhqx" */  './zhanghu/zhgl-compose.vue');
const Jsgl = () => import(/* webpackChunkName: "Yhqx" */  './juese/juese.vue');
const Zzjg = () => import(/* webpackChunkName: "Yhqx" */  './zuzhijiagou/zuzhijiagou.vue');
const Sjqxgl = () => import(/* webpackChunkName: "Yhqx" */  './shujuquanxian/shujuquanxian.vue');
const YqmList = () => import(/* webpackChunkName: "Yhqx" */  './yaoqingma/yqm-list.vue');



const routers: RouteConfig[] = [
    {
        path: 'zhgl-list',
        component: ZhglList,
    },
    {
        path: 'zhgl-compose',
        component: ZhglCompose,
    },
    {
        path: 'jsgl',
        component: Jsgl,
    },
    {
        path: 'zzjg',
        component: Zzjg,
    },
    {
        path: 'sjqxgl',
        component: Sjqxgl,
    },
    {
        path: 'yqm-list',
        component: YqmList,
    },
    {
        path: '',
        redirect: 'zhgl-list'
    }
];

export default routers;
